import { Component } from '@angular/core';
import { CoStructureSyncService } from 'projects/mydocma/co/src/lib/common/bp/structure/co-structure-sync.service';
import { CoStructureSyncViewService } from 'projects/mydocma/co/src/lib/common/bp/structure/co-structure-sync-view.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mydocma-app-bp';

  constructor(
    _coStructureSyncService: CoStructureSyncService,
    _coStructureSyncViewService: CoStructureSyncViewService,
  ) {}
}
